/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import {
  BackButton,
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  LoadingComponent,
  PreviewCard,
  ReactDataTable,
  ReportStatusDropdown,
} from "../../../components/Component";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { ImportExportButton } from "../../../components/button/ActionButton";
import {
  UserPermissionType,
  isCheckToList,
  UserActionType,
  isAllowToAccess,
} from "../../../services/permission/permission";
import { scrollToTop, showErrorToast, showSuccessToast } from "../../../utils/Functions";
import { parseUrlParams, updateHash, removeWhitespace, ReportStatusTypes, createUrlHash } from "../../../utils/Utils";
import { PER_PAGE_ITEMS } from "../../../utils";
import {
  listProgressReportAPI,
  removeProgressReportAPI,
  exportProgressReportAPI,
  ReportTableData,
  extendProgressReportAPI,
} from "./ReportData";
import { ConfirmationAlert } from "../../../components/alerts/Alerts";
import ExtendModal from "./ExtendModal";
import moment from "moment";
const ReportList = () => {
  const location = useLocation();
  const history = useHistory();
  const [reportList, setReportList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [initScreen, setInitScreen] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [sortId, setSortId] = useState();
  const [sortOrder, setSortOrder] = useState("asc");
  const [clientId, setClientId] = useState(null);
  const [carerId, setCarerId] = useState(null);
  const [clientName, setClientName] = useState("");
  const [carerName, setCarerName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [reportStatus, setReportStatus] = useState(undefined);
  const [extendModalVisible, setExtendModalVisible] = useState(false);
  const [selectedReportRow, setSelectedReportRow] = useState(null);
  useEffect(() => {
    const params = parseUrlParams();

    // Handle status from URL params
    if (params.status) {
      const selectedStatus = ReportStatusTypes.find(
        (option) => removeWhitespace(option.value) === removeWhitespace(params.status),
      );
      if (selectedStatus && selectedStatus.value !== reportStatus?.value) {
        setReportStatus(selectedStatus);
      }
    }

    // Handle clientId from URL params, client table, or navigation state
    let newClientId = null;
    if (params.clientId) {
      newClientId = parseInt(params.clientId, 10);
    } else if (location?.state?.clientId) {
      newClientId = location.state.clientId;
    } else if (location?.state?.data && !location?.state?.carerId) {
      newClientId = location.state.data;
    }

    // Handle carerId from URL params, carer table, or navigation state
    let newCarerId = null;
    if (params.carerId) {
      newCarerId = parseInt(params.carerId, 10);
    } else if (location?.state?.carerId) {
      newCarerId = location.state.carerId;
    }

    // Update state
    if (newClientId !== null) {
      setClientId(newClientId);
    }
    if (newCarerId !== null) {
      setCarerId(newCarerId);
    }

    // Handle clientName from URL params or navigation state
    let newClientName = "";
    if (params.clientName) {
      newClientName = decodeURIComponent(params.clientName);
    } else if (location?.state?.clientName) {
      newClientName = location.state.clientName;
    }

    // Update state
    if (newClientName) {
      setClientName(newClientName);
    }

    // Handle carerName from URL params or navigation state
    let newCarerName = "";
    if (params.carerName) {
      newCarerName = decodeURIComponent(params.carerName);
    } else if (location?.state?.carerName) {
      newCarerName = location.state.carerName;
    }

    // Update state
    if (newCarerName) {
      setCarerName(newCarerName);
    }

    // Update URL hash if we have IDs or names from state but not in URL
    if (
      (newClientId || newCarerId || newClientName || newCarerName) &&
      !params.clientId &&
      !params.carerId &&
      !params.clientName &&
      !params.carerName
    ) {
      const hashParams = {
        pathname: location.pathname,
        clientId: newClientId,
        carerId: newCarerId,
        clientName: newClientName,
        carerName: newCarerName,
      };
      if (currentPage && currentPage > 1) {
        hashParams.page = currentPage;
      }
      updateHash(hashParams);
    }
  }, [location]);

  // Handle initial date range from DateRangePicker
  const handleDateRangeChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
    setCurrentPage(1);
  };
  useEffect(() => {
    if (!currentPage) return;
    // if (startDate && endDate) {
    //   loadReportList();
    // } else {
    //   // Wait for DateRangePicker to initialize (it sets dates on mount)
    //   const timer = setTimeout(() => {
    //     loadReportList();
    //   }, 200);
    //   return () => clearTimeout(timer);
    // }
    if (clientId || carerId) {
      loadReportList();
    }
  }, [currentPage, clientId, carerId, startDate, endDate]);
  useEffect(() => {
    if (initScreen) return;
    // Only reload if dates are actually set (not empty strings)
    // if (startDate && endDate) {
    //   if (currentPage === 1) {
    //     loadReportList();
    //   } else {
    //     setCurrentPage(1);
    //   }
    // }
    if (clientId || carerId) {
      if (currentPage === 1) {
        loadReportList();
      } else {
        setCurrentPage(1);
      }
    }
  }, [sortId, sortOrder, startDate, endDate, reportStatus, clientId, carerId]);
  useEffect(() => {
    const params = parseUrlParams();
    if (params.page) {
      setCurrentPage(parseInt(params.page, 10));
    } else {
      setCurrentPage(1);
    }
  }, [location]);
  const loadReportList = () => {
    scrollToTop();
    if (isCheckToList(UserPermissionType.report)) {
      setIsLoading(true);
      const params = {
        pageInfo: {
          pageIndex: currentPage,
          itemsPerPage: PER_PAGE_ITEMS,
        },
        // startDate: startDate || "",
        // endDate: endDate || "",
        carerId: carerId || 0,
        clientId: clientId || 0,
        status: reportStatus?.value || "",
      };
      listProgressReportAPI(params, (data, error) => {
        if (!error) {
          setReportList(data?.list ?? []);
          if (currentPage === 1) {
            setTotalItems(data?.pageInfo?.totalItems ?? 0);
          }
        }
        setIsLoading(false);
        setInitScreen(false);
      });
    } else {
      setInitScreen(false);
      setIsLoading(false);
    }
  };
  const updateQueryParams = (updates) => {
    updateHash({
      page: currentPage,
      pathname: location.pathname,
      status: reportStatus?.value,
      clientId: clientId,
      carerId: carerId,
      clientName: clientName,
      carerName: carerName,
      startDate: startDate,
      endDate: endDate,
      ...updates,
    });
  };
  const onPageChanged = (page) => {
    setCurrentPage(page);
    updateHash({
      page: page,
      pathname: location.pathname,
      status: reportStatus?.value,
      clientId: clientId,
      carerId: carerId,
      clientName: clientName,
      carerName: carerName,
      startDate: startDate,
      endDate: endDate,
    });
  };
  const onAddClick = () => {
    history.push({
      pathname: `${process.env.PUBLIC_URL}/add-report`,
      state: {
        clientId: clientId,
        carerId: carerId,
        isListEmpty: reportList.length === 0,
      },
    });
  };
  const onEdit = (row) => {
    const isViewOnly = row?.status === "COMPLETED";
    history.push({
      pathname: `${process.env.PUBLIC_URL}/add-report`,
      state: {
        reportId: row?.id,
        isEdit: true,
        isViewOnly: isViewOnly,
        clientId: clientId,
        carerId: carerId,
      },
    });
  };
  const onExtend = (row) => {
    setSelectedReportRow(row);
    setExtendModalVisible(true);
  };
  const handleExtendSaved = (date, reason) => {
    setLoading(true);
    // Format date for display
    const formattedDate = date ? moment(date).format("YYYY-MM-DD") : null;
    const params = {
      id: selectedReportRow?.id,
      extendDate: formattedDate,
      reason: reason,
    };
    extendProgressReportAPI(params, (data, error) => {
      if (!error) {
        showSuccessToast("Report extended successfully");
        loadReportList();
      } else {
        showErrorToast(error?.message);
      }
      setLoading(false);
    });
    setExtendModalVisible(false);
    setSelectedReportRow(null);
  };
  const handleExtendClosed = () => {
    setExtendModalVisible(false);
    setSelectedReportRow(null);
  };
  const onRemove = (row) => {
    ConfirmationAlert("Are you sure?", "Do you want to remove this report?", () => {
      removeProgressReportAPI(
        {
          id: row?.id,
        },
        (data, error) => {
          if (!error) {
            showSuccessToast("Report removed successfully");
            loadReportList();
          } else {
            showErrorToast(error?.message);
          }
        },
      );
    });
  };
  const onExport = () => {
    setLoading(true);
    let params = {
      //   startDate: startDate || "",
      //   endDate: endDate || "",
      carerId: carerId,
      clientId: clientId,
      status: reportStatus?.value || "",
    };
    exportProgressReportAPI(params, (data, error) => {
      if (!error) {
        window.open(data.fileUrl, "default");
      } else {
        showErrorToast(error?.message || "Export failed");
      }
      setLoading(false);
    });
  };
  const handleBackClick = () => {
    // Navigate back to the appropriate list page based on the current route
    const isActiveClientsReportList = location.pathname.includes("/reports/active-clients/reports-list");
    const isClientsReportList = location.pathname.includes("/reports/clients/reports-list");
    if (isClientsReportList || isActiveClientsReportList) {
      // Get preserved filters from navigation state
      const preservedFilters = location?.state?.preservedFilters || {};

      // Build hash parameters with preserved filters
      const hashParams = {};

      // Add preserved filters to hash params
      if (preservedFilters.clientType) {
        hashParams.clientType = preservedFilters.clientType;
      }
      if (preservedFilters.progressStatus) {
        hashParams.progressStatus = preservedFilters.progressStatus;
      }
      if (preservedFilters.status) {
        hashParams.status = preservedFilters.status;
      }
      if (preservedFilters.branch) {
        hashParams.branch = preservedFilters.branch;
      }
      if (preservedFilters.agency) {
        hashParams.agency = preservedFilters.agency;
      }
      if (preservedFilters.search) {
        hashParams.searchText = preservedFilters.search;
      }
      if (preservedFilters.month) {
        hashParams.month = preservedFilters.month;
      }
      if (preservedFilters.page) {
        hashParams.page = preservedFilters.page;
      }

      // Build hash string and include it in navigation
      const hash = createUrlHash(hashParams);
      const listBasePath = isActiveClientsReportList ? "/reports/active-clients" : "/reports/clients";
      const targetPath = `${process.env.PUBLIC_URL}${listBasePath}${hash}`;

      // Navigate to client list page with filters in URL
      history.push(targetPath);
    } else if (
      location.pathname.includes("/reports/carers/reports-list") ||
      location.pathname.includes("/reports/active-carers/reports-list")
    ) {
      // Get preserved filters from navigation state for carers
      const preservedFilters = location?.state?.preservedFilters || {};

      // Build hash parameters with preserved filters
      const hashParams = {};

      // Add preserved filters to hash params
      if (preservedFilters.progressStatus) {
        hashParams.progressStatus = preservedFilters.progressStatus;
      }
      if (preservedFilters.status) {
        hashParams.status = preservedFilters.status;
      }
      if (preservedFilters.grade) {
        hashParams.grade = preservedFilters.grade;
      }
      if (preservedFilters.branch) {
        hashParams.branch = preservedFilters.branch;
      }
      if (preservedFilters.carerType) {
        hashParams.carerType = preservedFilters.carerType;
      }
      if (preservedFilters.search) {
        hashParams.searchText = preservedFilters.search;
      }
      if (preservedFilters.month) {
        hashParams.month = preservedFilters.month;
      }
      if (preservedFilters.page) {
        hashParams.page = preservedFilters.page;
      }

      // Build hash string and include it in navigation
      const hash = createUrlHash(hashParams);
      const listBasePath = location.pathname.includes("/reports/active-carers/reports-list")
        ? "/reports/active-carers"
        : "/reports/carers";
      const targetPath = `${process.env.PUBLIC_URL}${listBasePath}${hash}`;

      // Navigate to carer list page with filters in URL
      history.push(targetPath);
    } else {
      // Fallback to browser back
      history.goBack();
    }
  };
  const reportTableColumns = ReportTableData(null, onEdit, onRemove, onExtend, false);
  return (
    <React.Fragment>
      <Head title="Client Reports List" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween className="flex-wrap">
            <BlockHeadContent>
              <BlockTitle page>Reports List</BlockTitle>
              <BlockDes className="text-soft">
                <p>
                  {carerName ? `Reports for ${carerName}` : clientName ? `Reports for ${clientName}` : "Reports"} -
                  Total {totalItems} reports
                </p>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent className="ms-auto">
              <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-end">
                {/* <span className="p-1">
                  <DateRangePicker
                    onDateChange={handleDateRangeChange}
                    urlDates={startDate && endDate ? { startDate, endDate } : undefined}
                    isMonthPicker={true}
                  />
                 </span> */}
                <span className="p-1">
                  <ReportStatusDropdown
                    value={reportStatus}
                    className="w-150px"
                    placeholder="Select Status"
                    isShowAll={true}
                    onSelect={(status) => {
                      setReportStatus(status);
                      setCurrentPage(1);
                      updateQueryParams({
                        status: status?.value,
                        page: 1,
                      });
                    }}
                  />
                </span>
                {isAllowToAccess(UserPermissionType.report, UserActionType.export) && (
                  <span className="p-1">
                    <ImportExportButton title={"Export"} onClick={onExport} iconName={"arrow-up"} loading={loading} />
                  </span>
                )}
                {isAllowToAccess(UserPermissionType.report, UserActionType.add) && (
                  <span className="p-1">
                    <ImportExportButton addButton title={"Add"} onClick={onAddClick} iconName={"plus"} />
                  </span>
                )}
                <span className="p-1">
                  <BackButton onClick={handleBackClick} />
                </span>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewCard className={"hospital-list-table"}>
            <ReactDataTable
              data={reportList}
              columns={reportTableColumns}
              isAllowed={isCheckToList(UserPermissionType.report)}
              totalItemCount={totalItems}
              pageNum={currentPage}
              pagination
              onPageChanged={onPageChanged}
              onSort={(id) => {
                setSortId(id);
                setSortOrder(sortOrder === "desc" ? "asc" : "desc");
              }}
            />
          </PreviewCard>
        </Block>
      </Content>
      <LoadingComponent isLoading={initScreen || isLoading} />
      <ExtendModal
        visible={extendModalVisible}
        item={selectedReportRow}
        onSaved={handleExtendSaved}
        onClosed={handleExtendClosed}
      />
    </React.Fragment>
  );
};
export default ReportList;
